import React from 'react';
import { useAuth } from '@hooks/useAuth';

export const QuotaDisplay: React.FC = () => {
  const { questionsRemaining } = useAuth();

  const getQuotaColor = () => {
    if (questionsRemaining <= 1) return 'text-red-400';
    if (questionsRemaining <= 3) return 'text-yellow-400';
    return 'text-gray-400';
  };

  return (
    <div className={`text-xs md:text-sm ${getQuotaColor()} px-3 py-2 md:px-4 text-center md:text-left`}>
      {questionsRemaining} question{questionsRemaining !== 1 ? 's' : ''} remaining today
    </div>
  );
};
